import ReactJkMusicPlayer from "react-jinke-music-player";
import "react-jinke-music-player/assets/index.css";
import ANNur from '../assets/audio/annur-ayat-32.mp3';
import ArRum from '../assets/audio/arrum-ayat-21.mp3';
import ANNisa from '../assets/audio/annisa-ayat-1.mp3';
import Amarona from '../assets/audio/amarona-maher-zain.mp3';
import Jafl from '../assets/audio/jafal-ashab.mp3';
import Sukron from '../assets/audio/sukron-ya-rabb.mp3';
import Alquran from '../assets/image/alquran.jpeg';
import Sound from '../assets/image/sound.png';
import Maher from '../assets/image/maher.jpeg';
// import "./styles.css";

const audioLists = [
  {
    name: "Surah AN Nur Ayat 32",
    singer: "misyari rasyid",
    cover: Alquran,
    musicSrc:
      ANNur
  },
  {
    name: "Surah AR RUM Ayat 21",
    singer: "bandung yaditth",
    cover: Alquran,
    musicSrc:
      ArRum
  },
  {
    name: "Surah AN NISA Ayat 1",
    singer: "misyari rasyid",
    cover: Alquran,
    musicSrc:
      ANNisa
  },
  {
    name: "AMARONA",
    singer: "maher zain",
    cover: Maher,
    musicSrc:
      Amarona
  },
  {
    name: "Jafal Ashab",
    singer: "jafal ashab",
    cover: Sound,
    musicSrc:
      Jafl
  },
  {
    name: "Sukron Ya Rabb",
    singer: "misyari rasyid",
    cover: Maher,
    musicSrc:
      Sukron
  },
];

export default function Music() {
  return (
    <div className="flex justify-center">
      <div className="Playing-music">
        <ReactJkMusicPlayer
          audioLists={audioLists}
          showMediaSession
          autoPlay={false}
          defaultPosition={{top:'85%',left:'47%'}}
        />
      </div>
    </div>
  );
}
